import { Div } from '@codesuma/baseline'

export const PageHeader = (title = '') => {
    const base = Div(title)

    base.style({
        position: 'absolute',
        top: 'env(safe-area-inset-top)',
        right: '0',
        left: '0',
        zIndex: '2',
        height: '60px',
        backgroundColor: '#fff',
        fontSize: '1.125rem',
        fontWeight: 'bold',
        padding: '18px 0px 17px 0px',
        textAlign: 'left',
        transition: 'all .24s',
    })


    return Object.assign(base, {
        toggleShadow(v: number) {
            base.style({ boxShadow: v > 10 ? '#00000012 0px 5px 8px' : '#00000000 0px 5px 8px' })
        },
    })
}